module.exports = __webpack_public_path__ + "static/media/logoDark.d1992aca.svg";